<a href="javascript:void(0)" tabindex="0" type="button" role="button"
    (click)="dismiss($event)" (keydown.space)="dismiss($event)"
    class="modal-close td-icon td-icon-close"
    [attr.aria-label]="'common-ui.tooltip.closeIcon.accessibilityTag' | translate">
</a>
